var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2608_2137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5066 36.7576C48.078 36.7576 44.7116 36.2214 41.5215 35.1671C39.9583 34.634 38.0367 35.1231 37.0826 36.1029L30.786 40.8562C23.4837 36.9583 18.9856 32.4616 15.1409 25.2141L19.7543 19.0816C20.9529 17.8846 21.3828 16.136 20.8677 14.4954C19.809 11.2885 19.2711 7.92371 19.2711 4.49371C19.2713 2.01585 17.2554 0 14.7777 0H4.49356C2.01585 0 0 2.01585 0 4.49356C0 32.8946 23.1055 56 51.5066 56C53.9843 56 56.0002 53.9841 56.0002 51.5064V41.251C56 38.7734 53.9841 36.7576 51.5066 36.7576Z",
    fill: "#21E786"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2608_2137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fd195e2ed0459b982b9bb2733eec27cc.svg";
export { ForwardRef as ReactComponent };